/**
 * Generate edit URL for an initiative based on its owner type
 *
 * @param ownerType - The type of owner (system, entity, user, etc.)
 * @param ownerId - The ID of the owner
 * @param initiativeId - The ID of the initiative
 * @returns The edit URL or null if owner type is not supported
 */
export function getInitiativeEditUrl(
  ownerType: string,
  ownerId: number,
  initiativeId: number
): string | null {
  const ownerTypeRoutes: Record<string, (ownerId: number, initiativeId: number) => string> = {
    system: (_, initiativeId) => `/admin/initiatives/${initiativeId}/edit`,
    entity: (ownerId, initiativeId) =>
      `/entities/${ownerId}/admin/initiatives/${initiativeId}/edit`,
    // Add more owner types here as needed:
    // user: (ownerId, initiativeId) => `/users/${ownerId}/initiatives/${initiativeId}/edit`,
  };

  const routeGenerator = ownerTypeRoutes[ownerType];
  if (!routeGenerator) return null;

  return routeGenerator(ownerId, initiativeId);
}
